<template>
  <slot
    name="trigger"
    :open="open"
  >
    <Button
      type="outline"
      class="detail-btn ml-16"
      @click="(event) => open(event.currentTarget)"
    >
      {{ $t('R4026') }}
    </Button>
  </slot>

  <div
    v-show="visible"
    ref="popupRef"
    class="strength-exercise-detail border border-border-1 rounded-sm bg-bg-5"
    :class="position4detailPopup"
    :style="position4detailPopup"
  >
    <div class="flex px-32 py-16 border-b border-border-1 section">
      <div
        v-if="activeStrengthExercise.access === ACCESS_OFFICIAL"
        class="mr-32"
      >
        <div class="block-image strength-image-intro rounded-sm">
          <img :src="activeStrengthExercise.videoUrl || activeStrengthExercise.sourceUrl" />
        </div>
      </div>
      <div class="flex-grow w-10 strength-params">
        <dl
          v-if="activeStrengthExercise.partText"
          class="introduce-item"
        >
          <dt>{{ $t('R4018') }}</dt>
          <dd>{{ activeStrengthExercise.partText }}</dd>
        </dl>
        <dl
          v-if="activeStrengthExercise.muscleText"
          class="introduce-item"
        >
          <dt>{{ $t('R4020') }}</dt>
          <dd>{{ activeStrengthExercise.muscleText }}</dd>
        </dl>
        <dl
          v-if="activeStrengthExercise.equipmentText"
          class="introduce-item"
        >
          <dt>{{ $t('R4023') }}</dt>
          <dd>{{ activeStrengthExercise.equipmentText }}</dd>
        </dl>
      </div>
    </div>
    <div class="section border-b border-dark-150 px-32 py-16">
      <dl class="introduce-item">
        <dd>
          <!--              官方的动作-->
          <template v-if="activeStrengthExercise.access === ACCESS_OFFICIAL">{{ activeStrengthExercise.descText }}</template>
          <!--              自定义动作-->
          <template v-else-if="activeStrengthExercise.overview">{{ activeStrengthExercise.overview }}</template>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script setup>
import { ref, nextTick } from 'vue';
import { Button } from '@arco-design/web-vue';
import { computePosition, flip, shift, offset, autoUpdate } from '@floating-ui/dom';

const ACCESS_OFFICIAL = 0;
const position4detailPopup = ref({});
const popupRef = ref(null);
const visible = ref(false);
const props = defineProps({
  activeStrengthExercise: {
    type: Object,
    default: () => ({})
  }
});
const emit = defineEmits(['close']);
let triggerEl = null;
let cleanUpAutoUpdate = null;

const computeAndApplyPopPosition = (referenceEl, floatingEl, offsetX, offsetY) => {
  const middleware = [
    offset(({ rects }) => {
      return {
        mainAxis: -rects.reference.width
      };
    }),
    flip({
      fallbackPlacements: ['left']
    }),
    shift()
  ];

  return computePosition(referenceEl, floatingEl, {
    placement: 'right',
    strategy: 'fixed',
    middleware
  });
};

const removeOutsideListener = () => {
  document.documentElement.removeEventListener('mousedown', handleOutsideClick);
};

const close = () => {
  removeOutsideListener();
  visible.value = false;
  triggerEl = null;
  cleanUpAutoUpdate();
  cleanUpAutoUpdate = null;
  emit('close');
};

const handleOutsideClick = (e) => {
  if (popupRef.value?.contains(e.target) || triggerEl?.contains(e.target)) {
    return;
  }

  close();
};

const open = (el) => {
  triggerEl = el;
  visible.value = true;
  nextTick(() => {
    cleanUpAutoUpdate = autoUpdate(triggerEl, popupRef.value, () => {
      computeAndApplyPopPosition(triggerEl, popupRef.value, 0, 0).then(({ x, y }) => {
        position4detailPopup.value = { left: `${x}px`, top: `${y}px` };
        document.documentElement.addEventListener('mousedown', handleOutsideClick);
      });
    });
  });
};
</script>

<style lang="scss" scoped>
@import '@client/styles/_mixins.scss';

.strength-exercise-detail {
  width: px2rem144(521);
  position: fixed;
  z-index: 999;
  .border-dark-150 {
    border-color: rgba(255, 255, 255, 0.05);
  }
  .section {
    &:nth-last-of-type(1) {
      height: px2rem144(187);
      border-bottom: 0;
      overflow: auto;
    }
    .strength-image-intro {
      width: px2rem144(200);
      height: px2rem144(200);
    }
    .strength-params {
      padding: px2rem144(16) 0 0 0;
    }

    .introduce-item {
      @apply mb-8;

      &:nth-last-of-type(1) {
        margin-bottom: 0;
      }

      dt {
        @apply text-12;
        font-weight: 400;
        @apply text-text-3;
        line-height: 18px;
      }

      dd {
        @apply text-14;
        font-weight: 500;
        @apply text-text-2;
        line-height: 20px;
        white-space: pre-wrap;
      }
    }
  }
}
</style>
